import { createElementBlock as r, openBlock as l, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
function n(m, e) {
  return l(), r("svg", t, e[0] || (e[0] = [
    o("path", { d: "M9.931 12.645h4.138l-2.07-4.908m0-7.737L.68 3.982l1.726 14.771L12 24l9.596-5.242L23.32 3.984zm7.064 18.31h-2.638l-1.422-3.503H8.996l-1.422 3.504h-2.64L12 2.65z" }, null, -1)
  ]));
}
const c = { render: n };
export {
  c as default,
  n as render
};
